// extracted by mini-css-extract-plugin
module.exports = {"title":"components-QuestionTemplateNext-Question-RadioButtonQuestion-RadioButtonQuestion__title--2xVc9"};